import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-upload';
export var ID = 'icon-upload';
/* eslint-disable max-len */

export var SVGUpload = function SVGUpload() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 24 20"
  }, React.createElement("path", {
    d: "M19.397 5.886C18.727 2.483 15.755 0 12.21 0 9.79 0 7.578 1.16 6.205 3.123 2.69 3.33 0 5.873 0 9.08c0 3.323 2.67 6.026 5.953 6.026.467 0 .845-.378.845-.844 0-.466-.378-.844-.845-.844-2.35 0-4.265-1.946-4.265-4.337 0-2.44 2.142-4.283 4.982-4.283.294 0 .567-.153.72-.404 1.035-1.694 2.837-2.705 4.82-2.705 2.92 0 5.333 2.19 5.613 5.09.042.434.406.764.84.764 2.284 0 3.648 1.085 3.648 2.902 0 1.612-1.333 2.974-2.912 2.974h-2.503c-.466 0-.844.378-.844.844 0 .466.38.844.845.844h2.503c2.538 0 4.602-2.092 4.602-4.662 0-2.572-1.782-4.304-4.603-4.558zM12.18 8.112c-.316-.317-.876-.317-1.193 0l-2.975 2.976c-.33.33-.33.864 0 1.193.33.33.864.33 1.193 0l1.5-1.498v7.982c0 .466.378.844.844.844.465 0 .843-.378.843-.844v-8.052l1.57 1.57c.165.164.38.247.597.247.215 0 .43-.084.596-.25.33-.328.33-.862 0-1.192L12.18 8.112z",
    fill: "#4E4E4E",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var Upload = function Upload(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGUpload
  });
};

Upload.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Upload;